import posthog from "posthog-js";
import {
  isSEmbedAnalyticsEventMessage,
  toHostAnalyticsEventName,
  type SEmbedAnalyticsEventMessage,
} from "@norma-bi/s-embed-sdk";

export function consumeSEmbedAnalyticsMessage(
  value: unknown,
): value is SEmbedAnalyticsEventMessage {
  if (!isSEmbedAnalyticsEventMessage(value)) {
    return false;
  }

  const eventName = toHostAnalyticsEventName(value.event);
  if (eventName) {
    posthog.capture(eventName, value.properties);
  }
  return true;
}
